export default __webpack_public_path__ + "static/media/cristina.01d8da2c.jpg";